import { render, staticRenderFns } from "./PerformanceData.vue?vue&type=template&id=423ec81f&"
import script from "./PerformanceData.vue?vue&type=script&lang=js&"
export * from "./PerformanceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports